import React from 'react';
import ResetPassword from '../../components/ResetPassword';
import {resetPassword} from '../../containers/Authentication/LoginActions';
import { connect } from 'react-redux';
import Waitable from '../../components/Waitable';

class ResetPasswordContainer extends React.Component {
  constructor(props){
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(data) {
    let {match, dispatchPasswordReset} = this.props;
    let resetToken = match.params.token;
    dispatchPasswordReset({
      ...data,
      resetToken
    });
  }
  render(){    
    return (
      <Waitable entities={[this.props.passwordReset]}>
        <ResetPassword 
          success={this.props.passwordReset.get('data')}
          error={this.props.passwordReset.get('error')}
          onSubmit={this.onSubmit}         
        />
     </Waitable>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return ({ 
    dispatchPasswordReset: (data, cb) => dispatch( resetPassword(data, cb))});
 };

const mapStateToProps = (state) => {
  return ({ passwordReset: state.authentication.passwordReset, form: state.form.ResetForm});
 };
  
 
export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordContainer);


// WEBPACK FOOTER //
// ./src/containers/ResetPassword/ResetPasswordContainer.js